/**
 * PfPlayButton — the brand kit's canonical circular play button (§14.2,
 * `.pf-play-btn`). The SVG is the exact markup used on /pro-member
 * (app/pro-member/_client/PMInteractiveClient.tsx) and the Zoom help page:
 * a 96×96 dark scrim circle with a gold ring and a gold triangle.
 * Styling lives in globals.css `.pf-play-btn` — never restyle it per page.
 */
export default function PfPlayButton({
  label,
  onClick,
  className,
  tabIndex,
}: {
  label: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  /** Additive (2026-09-26): -1 keeps a duplicate copy (a marquee's clone set) out of the tab order. */
  tabIndex?: number;
}) {
  return (
    <button type="button" className={`pf-play-btn${className ? ` ${className}` : ''}`} aria-label={label} onClick={onClick} tabIndex={tabIndex}>
      <svg viewBox="0 0 96 96" width="96" height="96" aria-hidden="true">
        <circle cx="48" cy="48" r="46" fill="rgba(0,0,0,0.45)" stroke="var(--gold)" strokeWidth="2.5" />
        <polygon points="38,30 68,48 38,66" fill="var(--gold)" />
      </svg>
    </button>
  );
}
